module.exports = __webpack_public_path__ + "static/media/whichThinnerChoice.8ec86b55.mp3";